import React from "react"
import PaymentListing from "./paymentListing"

const PaymentListingPage = () => {
    
    return (
        <PaymentListing /> 
    )

}

export default PaymentListingPage


// WEBPACK FOOTER //
// ./src/payment/listing/paymentListingPage.tsx